<template>
    <el-dialog :visible.sync="visible" width="600px" title="优惠券数据">
        <div class="wrapper">
            <div class="card">
                <div class="key">已领取</div>
                <div class="val">{{ form.count }}</div>
            </div>
            <div class="card">
                <div class="key">使用数</div>
                <div class="val">{{ form.use_count }}</div>
            </div>
            <div class="card">
                <div class="key">失效数</div>
                <div class="val">{{ form.expire_count }}</div>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import { data } from "@/api/coupon/list";
export default {
    data() {
        return {
            visible: false,
            form: {},
        };
    },
    methods: {
        open(row) {
            this.visible = true;
            this.search(row.cuuid);
        },
        search(cuuid) {
            data({ cuuid }).then(({ code, result, error }) => {
                if (code === 200) {
                    this.form = result;
                } else {
                    this.$message.error(error.message);
                }
            });
        },
    },
};
</script>

<style lang="less" scoped>
.wrapper {
    display: flex;
    justify-content: center;
    gap: 20px;
    .card {
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 20px;
        background: #efefef;
        min-width: 150px;
        .val {
            font-size: 20px;
        }
    }
}
</style>
